/**
 * Specifies TreeMap beforePrint event name.
 *
 * @private
 */
export const smithchartBeforePrint = 'beforePrint';
